










































import Vue from "vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import account from "@/store/modules/account";

export default Vue.extend({
  name: "TopWarning",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState("session", ["billingAccounts", "user"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["hasUserManagementPermission", "hasAccountAdminPermission"]),
    freeTrialLeftString() {
      let account = (this as any).billingAccount;
      let today = moment();
      let endDate = account.freeTrial && account.freeTrial.endDate ? moment(account.freeTrial.endDate) : moment();

      if (today > endDate) {
        return 0;
      } else {
        let days = endDate.diff(today, "days");
        let hours = endDate.diff(today, "hours") % 24;

        return `${days} ${days > 1 ? "days" : "day"}, ${hours} ${hours > 1 ? "hours" : "hour"}`;
      }
    },
    freeTrialExpired() {
      let account = (this as any).billingAccount;
      return account.status === 1 && account.freeTrial && account.freeTrial.endDate && new Date(account.freeTrial.endDate) < new Date() && new Date(account.freeTrial.canceledDate) > new Date();
    },
    freeTrialCanceled() {
      let account = (this as any).billingAccount;
      return account.status === 1 && account.freeTrial && account.freeTrial.endDate && new Date(account.freeTrial.canceledDate) < new Date();
    },
    freeTrialExpiredDateString() {
      let account = (this as any).billingAccount;
      return account.freeTrial && account.freeTrial.endDate ? moment(account.freeTrial.endDate).format("L") : "";
    },
    freeTrialCanceledDateString() {
      let account = (this as any).billingAccount;
      return account.freeTrial && account.freeTrial.canceledDate ? moment(account.freeTrial.canceledDate).format("L") : "";
    },
    willBeCanceled() {
      let context = this as any;
      return context.billingAccount.status == 3 && context.billingAccount.cancelAt !== null;
    },
    willBeCanceledAt() {
      let context = this as any;
      return context.billingAccount.cancelAt !== null ? moment(context.billingAccount.cancelAt).format("L") : "";
    },
    canceled() {
      let account = (this as any).billingAccount;
      return account.status === 8;
    },
    hasBillingIssue() {
      let account = (this as any).billingAccount;
      return account.status === 2 || account.status === 4 || account.status === 5 || account.status === 6 || account.status === 7;
    },
    noLicenseAssigned() {
      let context = this as any;
      let account = context.billingAccount;

      if (this.freeTrialExpired || this.canceled || this.hasBillingIssue) {
        return false;
      }

      if (account && account.members && account.members.filter((m) => m.memberId === context.user.id && m.licenseAssigned === true).length > 0) {
        return false;
      }

      return true;
    },
    isAccountCreated() {
      let context = this as any;
      let accounts = context.billingAccounts.filter((a) => a.originalOwnerId == context.user.id);
      return accounts.length > 0;
    },
    isAccountOwner() {
      let context = this as any;
      return context.billingAccount.originalOwnerId === context.user.id;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    handleCreateAccount() {
      this.$router.push({ name: "createBillingAccount" });
    },
  },
});
